import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UseCase } from '../../base/usecase';
import { HttpResponseEntity } from '../../domain/common.models';
import { PinSettingData } from '../../domain/pin-creation-domain.models';
import { FSWalletPinTransactionRepository } from '../../repository/fs-wallet-pin-transaction.repository';

/**
 * Set PIN Use Case - Clean Architecture Application Layer
 * Sets PIN for wallet transactions after validation
 */
@Injectable({ providedIn: 'root' })
export class SetPinUsecase implements UseCase<PinSettingData, HttpResponseEntity> {
    constructor(private repository: FSWalletPinTransactionRepository) {}

    /**
     * Execute PIN setting
     * @param data - PIN setting data
     * @returns Observable of HTTP response entity
     */
    execute(data: PinSettingData): Observable<HttpResponseEntity> {
        return this.repository.SetPin(data);
    }
}
